export function normalizeLowerCase(str) {
  return str
    .replace(/ /g, '_')
    .replace('?', '')
    .normalize('NFD') // Formato de Normalização Canônico de Decomposição.
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}
